import React from "react";
import { Button } from "../../../designSystem/button/Button";
import { Flex } from "../../../designSystem/compositeComponents/FlexHelpers";
import { MessageCard } from "../../../designSystem/Message";

type ActivityInvitationStatusPanelProps = {
    activity: { start: Date, participantCount:number };
    status: 'not-sent' | 'up-to-date' | 'has-changes';
    onClick: () => void;
}

export function ActivityInvitationStatusPanel(props: ActivityInvitationStatusPanelProps) 
{
    const showInvitationWarning = 
        (props.activity.start > new Date()) && 
        (props.status === 'not-sent' || props.status === 'has-changes') &&
        (props.activity.participantCount > 0);

    return (
        <>
            {showInvitationWarning &&
                <MessageCard variant="warning" textAlign="left">
                    <Flex justifyContent="space-between" alignItems="center" gap={24}>
                        <div>
                            {props.status === 'has-changes' && 
                                <>Mødet er blevet opdateret. Husk at opdatere nye, eksisterende og fjernede deltagere om ændringerne med en e-mail.</> 
                            }

                            {props.status === 'not-sent' &&
                                <>Mødet er nyoprettet. Husk at sende en e-mail invitation til deltagerne.</> 
                            }
                        </div>
                        <Button text={props.status === 'has-changes' ? "Send opdatering" : "Send invitation"} variant="outlined" onClick={props.onClick} />
                    </Flex>
                </MessageCard>
                        
            }
        </>
    );
}